import React, {useState} from 'react';
import {Container, Collapse, Row, Col, Tabs, Tab, Table, Card, Form} from 'react-bootstrap';
import '../layout/main.scss';
import '../home/home.scss';
import './transactions.scss';


function MyWallet() {
    const [open, setOpen] = useState(false);

    return (
        <div className="App">
            <div className="transactions">
                <Container>
                    <h3>Transactions</h3>
                    <div className="transactions_filters">Filters
                        <Form.Select aria-label="SelectCollection">
                            <option>Collection</option>
                            <option value="1">Spells of Genesis</option>
                            <option value="2">Crypto Kitties</option>
                            <option value="3">Blah blah</option>
                        </Form.Select>
                        <Form.Select aria-label="SelectChain">
                            <option>Blockchain</option>
                            <option value="1">Bitcoin/Counterparty</option>
                            <option value="2">Ethereum</option>
                            <option value="3">Klaytn</option>
                            <option value="4">Kusama</option>
                        </Form.Select>
                    </div>
                    <div className="transactions_table">
                        Please insert existing table with existing style :)
                        <Table striped bordered hover>
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Asset/Contract</th>
                                <th>Image</th>
                                <th>Time</th>
                                <th>Blockchain</th>
                                <th>Collection</th>
                                <th>From</th>
                                <th>To</th>
                                <th>Qty</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>1</td>
                                <td>TROYGRUN</td>
                                <td>(image)</td>
                                <td>Timestamp</td>
                                <td>Counterparty</td>
                                <td>Spells of Genesis</td>
                                <td>1jnewfr...sd46z</td>
                                <td>1lfn84r...48fnh</td>
                                <td>1</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>TROYGRUN</td>
                                <td>(image)</td>
                                <td>Timestamp</td>
                                <td>Counterparty</td>
                                <td>Spells of Genesis</td>
                                <td>1jnewfr...sd46z</td>
                                <td>1lfn84r...48fnh</td>
                                <td>1</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>TROYGRUN</td>
                                <td>(image)</td>
                                <td>Timestamp</td>
                                <td>Counterparty</td>
                                <td>Spells of Genesis</td>
                                <td>1jnewfr...sd46z</td>
                                <td>1lfn84r...48fnh</td>
                                <td>1</td>
                            </tr>
                            </tbody>
                        </Table>
                    </div>

                </Container>
            </div>
        </div>
    );
}

export default MyWallet;
